import React from 'react';
import {Link} from 'react-router';
import moment from 'moment';

class RowItemDanhSachBaoCaoBCTH extends React.Component {

  render() {
    return (
      <tr>
        <td className='column-stt-fixed'>{this.props.count}</td>
        <td className='list-items-table'><Link className="txt-underline txt-regular" to={`/thong-ke-bao-cao/lap-bao-cao-tong-hop/${this.props.item.baoCaoTongHopChiTietId}`}>{this.props.item.loaiBaoCaoInfo ? this.props.item.loaiBaoCaoInfo.ten : ''}</Link></td>
        <td className='txt-left'>{this.props.item.trangThaiBaoCaoInfo ? this.props.item.trangThaiBaoCaoInfo.ten : ''}</td>
        <td className='txt-left'>{this.props.item.ngayTongHop ? moment(this.props.item.ngayTongHop).format('DD/MM/YYYY') : ''}</td>
      </tr>
    );
  }
}

export default RowItemDanhSachBaoCaoBCTH;



// WEBPACK FOOTER //
// ./src/components/modules/bao-cao-tong-hop/datatable/RowItemDanhSachBaoCaoBCTH.jsx